import React, { useCallback } from 'react';
import InternalStatusIndicator from '../../../status-indicator/internal';
import { fireNonCancelableEvent } from '../../events';
import { usePrevious } from '../../hooks/use-previous';
import styles from './styles.css.js';
var DropdownStatus = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.root }, children);
};
export var useDropdownStatus = function (_a) {
    var statusType = _a.statusType, empty = _a.empty, loadingText = _a.loadingText, finishedText = _a.finishedText, errorText = _a.errorText, recoveryText = _a.recoveryText, isEmpty = _a.isEmpty, isNoMatch = _a.isNoMatch, noMatch = _a.noMatch, onRecoveryClick = _a.onRecoveryClick;
    var statusResult = { isSticky: true, content: null };
    var previousStatusType = usePrevious(statusType);
    var handleRecoveryClick = useCallback(function (e) {
        e.preventDefault();
        fireNonCancelableEvent(onRecoveryClick);
    }, [onRecoveryClick]);
    if (statusType === 'loading') {
        statusResult.content = React.createElement(InternalStatusIndicator, { type: 'loading' }, loadingText);
    }
    else if (statusType === 'error') {
        statusResult.content = (React.createElement(React.Fragment, null,
            React.createElement(InternalStatusIndicator, { type: "error", __uxdgInverted: true, __animate: previousStatusType !== 'error' }, errorText),
            ' ',
            recoveryText && (React.createElement("a", { role: "button", tabIndex: -1, className: styles.recovery, onClick: handleRecoveryClick }, recoveryText))));
    }
    else if (isEmpty && empty) {
        statusResult.content = empty;
    }
    else if (isNoMatch && noMatch) {
        statusResult.content = noMatch;
    }
    else if (statusType === 'finished' && finishedText) {
        statusResult.content = finishedText;
        statusResult.isSticky = false;
    }
    return statusResult;
};
export default DropdownStatus;
//# sourceMappingURL=index.js.map